module.exports = __webpack_public_path__ + "img/iconGongChengBanGongDaoZha.61a84293.svg";